import { useState, useEffect } from 'react';
import { rechargeApi } from '@/services/api';
import {
  RechargeConfigData,
  ApiError,
  HookState
} from '@/services/types';

// Hook 返回值
interface UseRechargeConfigReturn extends HookState<RechargeConfigData> {
  // 手动刷新数据
  refresh: () => Promise<void>;
}

export function useRechargeConfig(): UseRechargeConfigReturn {
  const [data, setData] = useState<RechargeConfigData | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<ApiError | null>(null);

  // 获取数据的函数
  const fetchData = async (): Promise<void> => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await rechargeApi.getRechargeConfigs();
      setData(response.data);
    } catch (err) {
      const apiError: ApiError = {
        error_code: err instanceof Error ? -1 : (err as any).errorCode || -1,
        message: err instanceof Error ? err.message : '获取充值配置失败',
        details: err
      };
      setError(apiError);
      console.error('获取充值配置失败:', err);
    } finally {
      setLoading(false);
    }
  };

  // 手动刷新
  const refresh = async (): Promise<void> => {
    await fetchData();
  };

  // 初始化数据获取
  useEffect(() => {
    fetchData();
  }, []);

  return {
    data,
    loading,
    error,
    refresh
  };
}